import { Brain, Users, Code, Clock, Percent, Target } from "lucide-react";

export const GmailPromotionsKeyFindings = () => {
  const findings = [
    {
      icon: Brain,
      iconColor: "text-primary",
      bgColor: "bg-primary/10",
      title: "Machine Learning Classification",
      description: "Gmail uses neural networks trained on billions of emails to classify content. Signals include sender history, content patterns, HTML complexity, and user behavior.",
      stat: "AI-driven",
      statLabel: "real-time classification",
      source: "Google 2024"
    },
    {
      icon: Users,
      iconColor: "text-success",
      bgColor: "bg-success/10",
      title: "User Engagement Shapes Placement",
      description: "Your individual inbox behavior matters. If you consistently open emails from a sender, Gmail learns to prioritize them in your Primary tab.",
      stat: "Per-user",
      statLabel: "personalized sorting",
      source: "Gmail Support"
    },
    {
      icon: Code,
      iconColor: "text-warning",
      bgColor: "bg-warning/10",
      title: "HTML Complexity Triggers Promotions",
      description: "Heavily designed emails with multiple images, buttons, and marketing layouts signal promotional content. Plain text or simple HTML often lands in Primary.",
      stat: "HTML structure",
      statLabel: "impacts classification",
      source: "Litmus 2024"
    },
    {
      icon: Percent,
      iconColor: "text-info",
      bgColor: "bg-info/10",
      title: "Promotions Tab Has Good Engagement",
      description: "Research shows 68.8% of users regularly check their Promotions tab. Open rates average 19.2%—not dramatically lower than Primary's 22.8%.",
      stat: "68.8%",
      statLabel: "check Promotions regularly",
      source: "Validity 2024"
    }
  ];

  return (
    <section className="py-8 sm:py-10">
      <div className="mb-6 sm:mb-8">
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-2">
          How Gmail's Algorithm Works
        </h2>
        <p className="text-muted-foreground">
          Research-backed insights into Gmail's email classification system
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card border border-border rounded-xl p-5 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`shrink-0 w-10 h-10 rounded-xl ${finding.bgColor} flex items-center justify-center`}>
                <finding.icon className={`w-5 h-5 ${finding.iconColor}`} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display font-semibold text-foreground mb-1.5">
                  {finding.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-3">
                  {finding.description}
                </p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-lg font-bold text-foreground">{finding.stat}</span>
                    <span className="text-xs text-muted-foreground ml-1.5">{finding.statLabel}</span>
                  </div>
                  <span className="text-xs text-muted-foreground/60">{finding.source}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
